import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export abstract class BaseService<T> {
	protected baseUrl = environment.apiUrl;

	constructor(protected http: HttpClient) {}

	get(endpoint: string, params?: any): Observable<T> {
		return this.http.get<T>(`${this.baseUrl}${endpoint}`, params ? { params } : {});
	}
	// from Navid: This getAll() function only passing the request to http.get, while this is already available if child class can be called directly! Shall I eliminate it
	getAll(endpoint: string): Observable<T[]> {
		return this.http.get<T[]>(`${this.baseUrl}${endpoint}`);
	}

	getById<T>(endpoint: string, id?: number): Observable<T> {
		return this.http.get<T>(`${this.baseUrl}${endpoint}${id ? `/` : ``}${id ?? ``}`);
	}
	//getAllByOtherId is a generic function that can be used to get all records by a specific id. For example, get all vendors by same address_id
	getAllByOtherId(endpoint: string, id: number): Observable<T[]> {
		return this.http.get<T[]>(`${this.baseUrl}${endpoint}/${id}`);
	}

	//example of endpoint convention: insurance/{insuranceId}/branches
	//getAllByFkIs is a generic function that can be used to get all records by a specific foreign key id. For example, get all branches by insurance_id
	getAllByFkId(endpoint: string): Observable<T[]> {
		return this.http.get<T[]>(`${this.baseUrl}${endpoint}`);
	}

	create<T>(endpoint: string, recordDetail: T): Observable<T> {
		return this.http.post<T>(`${this.baseUrl}${endpoint}`, recordDetail);
	}

	// from Navid: recordDetial is a generic object that should match the data in db. The endPoint is how you would know which db table it is about.
	update<T>(endpoint: string, id: number, recordDetail: T): Observable<T> {
		return this.http.put<T>(`${this.baseUrl}${endpoint}/${id}`, recordDetail);
	}

	updateWithPatch<T>(endpoint: string, payload: any): Observable<T> {
		const body = { _method: 'patch', ...payload };
		return this.http.post<T>(`${this.baseUrl}${endpoint}`, body);
	}

	patch<T>(endpoint: string, payload: any): Observable<T> {
		const body = { ...payload };
		return this.http.patch<T>(`${this.baseUrl}${endpoint}`, body);
	}

	put<T>(endpoint: string, payload: any): Observable<T> {
		const body = { ...payload };
		return this.http.put<T>(`${this.baseUrl}${endpoint}`, body);
	}

	updateWithPost<T>(endpoint: string, payload: any): Observable<T> {
		const body = { ...payload };
		return this.http.post<T>(`${this.baseUrl}${endpoint}`, body);
	}

	// from Navid: recordDetial is a generic object that should match the data in db. The endPoint is how you would know which db table it is about.
	updateMultipleRecords<T>(endpoint: string, recordDetail: T): Observable<T> {
		/**
		 * Temporarily changed to POST to bypass the CORS issue,
		 * revert back to PATCH once CORS policy is set to allow POST.
		 */
		return this.http.post<T>(`${this.baseUrl}${endpoint}`, recordDetail);
	}

	delete(endpoint: string, id: number): Observable<void> {
		return this.http.delete<void>(`${this.baseUrl}${endpoint}/${id}`);
	}
}
